import React, { useEffect, useState } from 'react'
import styles from './index.module.css'
import List from './List';
import Dialog from './Dialog';
const Index = ({ chats }) => {
    
    const [selectedChat, setSelectedChat] = useState(null);
    
    return (
    <div className={styles.wrapper}>

        <List chats={chats} selectedChat={selectedChat} setSelectedChat={setSelectedChat}/>

        {selectedChat && <Dialog selectedChat={selectedChat} setSelectedChat={setSelectedChat}/>}
    </div>
  )
}

export default Index